import React from 'react';

export default function BillingInvoice() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Billing & Invoice</h1>
      <p className="text-gray-500">Halaman Billing & Invoice</p>
    </div>
  );
}
